export enum SortDirectionEnum {
  ASC = 'asc',
  DESC = 'desc',
}
